import React, { createContext, useCallback, useContext, useState } from "react";

const GameSessionContext = createContext(null);
const validRound = (round, owner) => typeof owner === 'string' && typeof round?.request_id === 'string' && Number.isSafeInteger(round.bet_minor) && Number.isSafeInteger(round.payout_minor);
export const GameSessionProvider = ({ children }) => {
  const [rounds, setRounds] = useState([]);
  const addRound = useCallback((round, owner) => {
    if (!validRound(round, owner)) return;
    setRounds((current) => { const clean = current.filter((item) => validRound(item, item.owner)); return clean.some((item) => item.request_id === round.request_id && item.owner === owner && item.game === (round.game || "keno")) ? clean : [...clean, {
      request_id: round.request_id, owner, game: round.game || "keno", bet_minor: round.bet_minor,
      payout_minor: round.payout_minor, created_at: round.created_at,
    }]; });
  }, []);
  const reset = useCallback((owner) => setRounds((current) => current.filter((round) => round.owner !== owner)), []);
  return <GameSessionContext.Provider value={{ rounds, addRound, reset }}>{children}</GameSessionContext.Provider>;
};
export const useGameSession = () => useContext(GameSessionContext);